// extracted by mini-css-extract-plugin
export default {"ViewClient":"viewClient_ViewClient__kluv+","form":"viewClient_form__GMQsi"};